import { useMutation } from "@apollo/client";
import mapValidationErrors, { mapServerErrors } from "helpers/graphqlErrors";
import { fetchAbsolute } from "helpers/router";
import LOGIN from "./queries/login.gql";

const useAuthLogin = () => {
  const [login, { data, loading, error }] = useMutation(LOGIN, { errorPolicy: "all" });

  let location = null;
  let errors = {};
  let submitError = null;

  if (!loading && data && data.hasOwnProperty("login")) {
    if (data.login !== null) {
      location = data.login.intended ?? fetchAbsolute("web.dashboard");
    }
  }

  if (!loading && error && error.graphQLErrors) {
    errors = mapValidationErrors(error.graphQLErrors);
    submitError = mapServerErrors(error.graphQLErrors);
  }

  return {
    login: (email, password, mfaCode, captchaToken) => {
      const mfa = mfaCode ? { type: "Authenticator", code: mfaCode } : null;
      login({
        variables: { email, password, mfa },
        context: {
          headers: {
            "x-captcha-token": captchaToken,
          },
        },
      });
    },
    location,
    errors,
    submitError,
    loading,
  };
};

export default useAuthLogin;
